/* ============================================================
   BLINKIE PETS — product page
   Variant selection -> price/total, cologne cross-sell,
   gallery thumbnails, sticky add-to-cart bar, and a cart add
   that includes the cologne as a second line item.
   Falls back gracefully: the native product form still works
   if JS is disabled (adds the selected variant).
   ============================================================ */
(function () {
  'use strict';

  /* ---- Shopify-style money formatter ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || '${{amount}}';
    function defaultTo(num, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    switch (f.match(placeholderRegex)[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' '); break;
      default: value = defaultTo(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }

  function initPdp(root) {
    var pdps = (root || document).querySelectorAll('[data-bp-pdp]');
    pdps.forEach(function (pdp) {
      if (pdp.dataset.bpPdpBound) return;
      pdp.dataset.bpPdpBound = '1';

      var moneyFormat = pdp.getAttribute('data-money-format') || '${{amount}}';
      var cologneId = pdp.getAttribute('data-cologne-id');
      var colognePrice = parseInt(pdp.getAttribute('data-cologne-price'), 10) || 0;

      var form = pdp.querySelector('.bp-pdp__form');
      var totalEl = pdp.querySelector('[data-bp-total]');
      var atc = pdp.querySelector('[data-bp-atc]');
      var cologneInput = pdp.querySelector('[data-bp-cologne]');
      var buybox = pdp.querySelector('[data-bp-buybox]');

      var sticky = document.getElementById('bp-stickybar-' + pdp.getAttribute('data-section-id'));
      var stickyTotal = sticky ? sticky.querySelector('[data-bp-sticky-total]') : null;
      var stickySet = sticky ? sticky.querySelector('[data-bp-sticky-set]') : null;
      var stickyCologne = sticky ? sticky.querySelector('[data-bp-sticky-cologne]') : null;
      var stickyAtc = sticky ? sticky.querySelector('[data-bp-sticky-atc]') : null;

      function selectedVariant() {
        var checked = form.querySelector('input[name="id"]:checked');
        if (checked) return checked;
        return form.querySelector('input[name="id"]'); // hidden (single variant)
      }
      function variantPrice(el) { return parseInt(el.getAttribute('data-price'), 10) || 0; }
      function cologneOn() { return cologneInput && cologneInput.checked; }

      function refresh() {
        var v = selectedVariant();
        if (!v) return;
        var total = variantPrice(v) + (cologneOn() ? colognePrice : 0);
        var money = formatMoney(total, moneyFormat);
        if (totalEl) totalEl.textContent = money;
        if (stickyTotal) stickyTotal.textContent = money;
        if (stickySet && v.getAttribute('data-title')) stickySet.textContent = v.getAttribute('data-title');
        if (stickyCologne) stickyCologne.textContent = cologneOn() && cologneId ? 'With cologne' : '';
      }

      form.addEventListener('change', function (e) {
        if (e.target.name === 'id' || e.target === cologneInput) refresh();
      });

      /* ---- Cart add (variant + optional cologne) ---- */
      function addToCart() {
        var v = selectedVariant();
        if (!v || v.disabled) return;
        var items = [{ id: parseInt(v.value, 10), quantity: 1 }];
        if (cologneOn() && cologneId) items.push({ id: parseInt(cologneId, 10), quantity: 1 });
        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = cartUrl; })
          .catch(function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
      }

      form.addEventListener('submit', function (e) {
        // Only intercept when we need multi-item (cologne) or fetch is available.
        if (window.fetch) { e.preventDefault(); addToCart(); }
      });
      if (stickyAtc) stickyAtc.addEventListener('click', addToCart);

      /* ---- Gallery thumbnails ---- */
      var main = pdp.querySelector('[data-bp-main] img');
      pdp.querySelectorAll('[data-bp-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (main && full) main.src = full;
          pdp.querySelectorAll('[data-bp-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
        });
      });

      /* ---- Sticky bar visibility ---- */
      if (sticky && buybox) {
        var onScroll = function () {
          var past = buybox.getBoundingClientRect().bottom < 0;
          sticky.setAttribute('data-on', past ? 'true' : 'false');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPdp(document); });
  } else {
    initPdp(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initPdp(e.target); });
})();
